import BrandService from './service';

export * from './reqres';

export default BrandService;
